import(/* webpackMode: "eager" */ "/carbonara/apps/webapp/src/app/global-error.tsx");
